var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgT({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.18 23.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.33,23.14c0,.35-.29.64-.64.64h-4.19c-.35,0-.64-.29-.64-.64V5.28h5.47v17.86ZM16.51,0c.35,0,.67.26.67.61v3.3c0,.14-.06.27-.14.37H.13c-.08-.1-.13-.23-.13-.37V.61C0,.26.29,0,.64,0h15.87Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgT);
export default __webpack_public_path__ + "static/media/T.44c76675f080c1a6e6bdc3164024e08a.svg";
export { ForwardRef as ReactComponent };